import { useTheme } from "@emotion/react";
import {
  Add,
  ArrowBack,
  CloseOutlined,
  EditOutlined,
  HistoryOutlined,
  LocalOfferOutlined,
  ManageAccounts,
  MoreVertOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Avatar,
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import EditOsComponent from "../editOsComponent";
import useStyles from "./styles";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import CopyButton from "../shared/copyButton";
import InfoField from "../shared/infoField";

export default function OsModalComponent(params) {
  const {
    osDetails,
    setOsDetails = () => {},
    isEdit = false,
    setOpenEditOS = () => {},
    openEditOS = false,
    setOpenNewOs = () => {},
    openNewOs = false,
    handleCloseSearchOs = () => {},
    erpId, // ERP da tela (opcional): enviado nas chamadas
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const [tecnicosSelecionados, setTecnicosSelecionados] = useState([]);
  const [disponibilidadeSelecionada, setDisponibilidadeSelecionada] = useState(
    [],
  );
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [dateEdited, setDateEdited] = useState(null);
  const [error, setError] = useState(false);
  const [loadingCreateOs, setLoadingCreateOs] = useState(false);
  const [paramsEditOs, setParamsEditOs] = useState(null);
  const [loadingParams, setLoadingParams] = useState(false);
  const [osHistorico, setOsHistorico] = useState([]);
  const [openHistorico, setOpenHistorico] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [tecnicos, setTecnicos] = useState([]);
  const [tipoOs, setTipoOs] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [disponibilidade, setDisponibilidade] = useState([]);
  const [agenda, setAgenda] = useState([]);
  const [statusOs, setStatusOs] = useState([]);
  const [paramsAberturaOs, setParamsAberturaOs] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const [dataProgramada, setDataProgramada] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setTecnicosSelecionados(item?.tecnicos || []);
    setDisponibilidadeSelecionada(item?.disponibilidade || []);
    setParamsEditOs({
      numero_ordem_servico: item?.numero_ordem_servico || null,
      idOs: item?.id || null,
      agenda: {
        id: item?.agenda?.id_agenda || null,
        descricao: item?.agenda?.descricao || null,
      },
      descricaoAbertura: item?.descricao_servico,
      disponibilidade: item?.disponibilidade || null,
      prioridade: {
        id_prioridade: item?.id_prioridade || null,
      },
      statusOs: item?.status_fechamento || null,
      tecnicos: item?.tecnicos || [],
      tipoOs: {
        id: item?.id_tipo_ordem_servico || null,
      },
    });
    setDataProgramada({
      data_inicio_programado: item?.data_inicio_programado || null,
      data_termino_programado: item?.data_termino_programado || null,
    });
  };
  const handleEditOS = () => {
    setOpenEditOS(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (openNewOs === true || openEditOS === true) {
      getParamsNewOS();
    }
  }, [openNewOs, openEditOS]);

  const getParamsNewOS = async () => {
    setLoadingParams(true);
    try {
      const response = await api.post("/interno/find/paramsNewOs", { erpId });

      setTecnicos(response?.data?.tecnicos || []);
      setTipoOs(response?.data?.tipoOs || []);
      setPrioridades(response?.data?.prioridade || []);
      setDisponibilidade(response?.data?.disponibilidade || []);
      setAgenda(response?.data?.agenda || []);
      setStatusOs(response?.data?.statusOs || []);
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };

  const editOs = async () => {
    if (
      !paramsEditOs?.tipoOs?.id ||
      !paramsEditOs?.prioridade?.id_prioridade ||
      paramsEditOs?.disponibilidade?.length === 0 ||
      !paramsEditOs?.disponibilidade ||
      !paramsEditOs?.agenda?.id ||
      !paramsEditOs?.statusOs ||
      !paramsEditOs?.data_inicio_programado ||
      (dateEdited &&
        paramsEditOs?.data_inicio_programado &&
        paramsEditOs?.hora_inicio_programado &&
        dayjs(
          `${paramsEditOs.data_inicio_programado} ${paramsEditOs.hora_inicio_programado}`,
        ).isBefore(dayjs())) ||
      !paramsEditOs?.data_termino_programado ||
      paramsEditOs?.tecnicos?.length === 0 ||
      !paramsEditOs?.tecnicos ||
      !paramsEditOs?.descricaoAbertura?.trim()
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setLoadingCreateOs(true);
    try {
      const response = await api.post("/interno/edit/os", {
        erpId,
        dataOs: paramsEditOs,
        idOs: paramsEditOs?.idOs,
        idAtendimento: osDetails?.id_atendimento,
      });
      const osEdited = response?.data?.ordem_servico?.find(
        (os) => os.id === paramsEditOs?.idOs,
      );

      setOsDetails(osEdited);
      setSnackbar({
        severity: "success",
        children: "OS editada com sucesso",
      });
    } catch (error) {
      console.error("Erro ao editar OS:", error);
      setSnackbar({
        severity: "error",
        children: "Erro ao editar OS",
      });
    } finally {
      setLoadingCreateOs(false);
      closeEditOs();
    }
  };

  const getOsHistorico = async () => {
    setOpenHistorico(true);
    setAnchorEl(null);
    try {
      const response = await api.post("/interno/find/historicoOs", {
        erpId,
        osId: paramsEditOs?.idOs,
      });
      setOsHistorico(response?.data);

      /*   setHistorico(response?.data); */
    } catch (error) {
      console.error("Erro ao buscar osHistorico:", error);
    }
  };
  function formatDescricao(mensagem) {
    return (
      <Box sx={{ padding: 1 }}>
        {mensagem?.split("\n\n")?.map((paragraph, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: "0.9375rem",
              lineHeight: 1.6,
              whiteSpace: "pre-wrap", // mantém quebras de linha originais
              overflowWrap: "break-word", // quebra palavras longas
              wordBreak: "break-word", // reforça quebra em palavras muito longas
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    );
  }

  const closeEditOs = () => {
    setDateEdited(false);
    setOpenEditOS(false);
    setTecnicosSelecionados([]);
    setDisponibilidadeSelecionada([]);

    setParamsEditOs(null);
    setError(false);
  };

  const closeNewOs = () => {
    setDateEdited(false);
    setOpenNewOs(false);
    setConfirmacaoSaidaPagina(false);
    setTecnicosSelecionados([]);
    setDisponibilidadeSelecionada([]);

    setParamsAberturaOs(null);
    setError(false);
  };

  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };
  function formatarNome(nome) {
    if (!nome) return "";

    return nome
      .toLowerCase() // tudo minúsculo
      .replace(/_/g, " ") // troca underscore por espaço
      .replace(/\s+/g, " ") // remove espaços extras
      .trim() // remove espaços no início/fim
      .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase()); // primeira letra de cada palavra maiúscula
  }

  const prioridade = {
    Baixa: theme.palette.colors.green.medium,
    Normal: theme.palette.colors.blue.medium,
    Alta: theme.palette.colors.orange.dark,
    Urgente: theme.palette.colors.red.medium,
  };
  const statusOrdemServico = {
    aberto: theme.palette.colors.blue.dark,
    em_andamento: theme.palette.colors.orange.dark,
    pendente: theme.palette.colors.pink.dark,
    finalizado: theme.palette.colors.green.dark,
    cancelado: theme.palette.colors.gray.dark,
    aguardando_agendamento: theme.palette.colors.gray.dark,
  };
  return (
    <Box sx={styles.containerComponent}>
      {openEditOS ? (
        <>
          <Box sx={styles.containerEditOs}>
            <Typography sx={styles.titleDescription}>
              <ManageAccounts sx={{ fontSize: "18px" }} />
              Editar OS - (Número OS: {paramsEditOs?.numero_ordem_servico})
            </Typography>
          </Box>
          <Box sx={{ ...styles.containerBodyModal, height: "80%" }}>
            <EditOsComponent
              setDateEdited={setDateEdited}
              loadingParams={loadingParams}
              loadingCreateOs={loadingCreateOs}
              tipoOs={tipoOs}
              error={error}
              prioridades={prioridades}
              disponibilidade={disponibilidade}
              statusOs={statusOs}
              setParamsAberturaOs={setParamsEditOs}
              paramsAberturaOs={paramsEditOs}
              agenda={agenda}
              setDisponibilidadeSelecionada={setDisponibilidadeSelecionada}
              setTecnicosSelecionados={setTecnicosSelecionados}
              tecnicosSelecionados={tecnicosSelecionados}
              tecnicos={tecnicos}
              disponibilidadeSelecionada={disponibilidadeSelecionada}
              dataInicioProgramada={dataProgramada?.data_inicio_programado}
              dataTerminoProgramada={dataProgramada?.data_termino_programado}
            />
          </Box>
          <Box sx={styles.containerActions}>
            <Button
              disabled={loadingCreateOs}
              onClick={() => closeEditOs()}
              size="small"
              variant="outlined"
            >
              Cancelar
            </Button>
            <LoadingButton
              loading={loadingCreateOs}
              onClick={() => editOs()}
              size="small"
              variant="contained"
            >
              Salvar
            </LoadingButton>
          </Box>
        </>
      ) : openHistorico ? (
        <>
          <Box sx={styles.containerHistorico}>
            <Tooltip title={"Voltar"}>
              <IconButton
                size="small"
                onClick={() => {
                  setOpenHistorico(false);
                  setOsHistorico([]);
                }}
                variant="outlined"
              >
                <ArrowBack fontSize="small" />
              </IconButton>
            </Tooltip>
            <Typography sx={styles.titleDescription}>
              {/* <HistoryOutlined sx={{ fontSize: "18px" }} /> */}
              Histórico - (Número OS: {paramsEditOs?.numero_ordem_servico})
            </Typography>
          </Box>

          <Box sx={{ ...styles.containerBodyModal, p: 4 }}>
            {osHistorico?.map((item, index) => (
              <Paper
                sx={{
                  ...styles.containerPaperMensagem,
                }}
                elevation={0}
                variant="outlined"
              >
                <Box sx={styles.bodyMensagem}>
                  <Box sx={styles.containerAvatar}>
                    <Avatar
                      src={item?.usuario?.link}
                      alt={item?.usuario?.nome}
                    />

                    <Box sx={{}}>
                      <Typography sx={styles.nameUser}>
                        {item?.usuario?.nome}
                      </Typography>
                      <Typography sx={styles.dataHistorico}>
                        {dayjs(item?.data_cadastro).format("DD/MM/YYYY HH:mm")}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Divider />{" "}
                <Box sx={{ padding: 2 }}>
                  <Typography sx={styles.textMensagem}>
                    {item?.descricao}
                  </Typography>{" "}
                </Box>
              </Paper>
            ))}
          </Box>
        </>
      ) : (
        <>
          <Box sx={styles.containerInfoOs}>
            <Box sx={styles.boxEdit}>
              <Typography sx={styles.titleDescription}>
                <ManageAccounts sx={{ fontSize: "22px" }} />
                OS - (Número OS: {osDetails?.numero_ordem_servico})
              </Typography>
            </Box>
            <Box sx={styles.boxEdit}>
              <Typography sx={styles.subtituloProtocolo}>
                <LocalOfferOutlined sx={{ fontSize: "16px", opacity: 0.7 }} />
                Ticket - (Protocolo: {osDetails?.protocolo_antedimento})
              </Typography>
            </Box>
            <IconButton
              onClick={handleCloseSearchOs}
              sx={styles.botaoFechar}
              size="small"
            >
              <CloseOutlined />
            </IconButton>
          </Box>

          <Box sx={styles.containerBodyModal}>
            <Box sx={styles.boxBodyModal}>
              <Box sx={styles.containerOS}>
                <Paper
                  sx={styles.containerPaper}
                  variant="outlined"
                  elevation={0}
                >
                  {/* Cabeçalho do cartão: o número da OS e o status são o que
                      identifica a ordem, então saem da grade de campos e
                      ganham a primeira linha. */}
                  <Box sx={styles.cardHeader}>
                    <Box sx={styles.cardHeaderIdentificacao}>
                      <Typography sx={styles.cardNumeroOs}>
                        OS {osDetails?.numero_ordem_servico}
                      </Typography>
                      <CopyButton
                        value={osDetails?.numero_ordem_servico}
                        setSnackbar={setSnackbar}
                        title="Copiar número da OS"
                        mensagem="Número da OS copiado!"
                      />
                      <Tooltip
                        title={
                          osDetails?.data_inicio_executado &&
                          !osDetails?.data_termino_executado
                            ? `Em execução desde ${dayjs(osDetails.data_inicio_executado).format("DD/MM/YYYY HH:mm")}`
                            : formatarNome(osDetails?.status_fechamento)
                        }
                      >
                        <Chip
                          size="small"
                          sx={{
                            ...styles.chip,
                            backgroundColor:
                              statusOrdemServico[osDetails?.status_fechamento],
                          }}
                          label={
                            osDetails?.data_inicio_executado &&
                            !osDetails?.data_termino_executado
                              ? `Em execução`
                              : formatarNome(osDetails?.status_fechamento)
                          }
                        />
                      </Tooltip>
                    </Box>

                    {!osDetails?.configTicket && (
                      <IconButton
                        onClick={(e) => handleClick(e, osDetails)}
                        size="small"
                        sx={styles.cardMenuButton}
                      >
                        <MoreVertOutlined fontSize="small" />
                      </IconButton>
                    )}
                  </Box>

                  <Divider />

                  <Box sx={styles.cardSecao}>
                    <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField
                          label="Agenda"
                          value={osDetails?.agenda?.descricao}
                          tooltip={osDetails?.agenda?.descricao}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField label="Disponibilidade">
                          {osDetails?.disponibilidade_str ? (
                            <Tooltip title={osDetails?.disponibilidade_str}>
                              <Chip
                                size="small"
                                sx={{
                                  ...styles.chip,
                                  backgroundColor:
                                    theme.palette.colors.purple.medium,
                                }}
                                label={osDetails?.disponibilidade_str}
                              />
                            </Tooltip>
                          ) : null}
                        </InfoField>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField label="Prioridade">
                          {osDetails?.prioridade ? (
                            <Tooltip title={osDetails?.prioridade}>
                              <Chip
                                size="small"
                                sx={{
                                  ...styles.chip,
                                  backgroundColor:
                                    prioridade[osDetails?.prioridade],
                                }}
                                label={osDetails?.prioridade}
                              />
                            </Tooltip>
                          ) : null}
                        </InfoField>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField label="Tipo de O.S.">
                          {osDetails?.tipo_ordem_servico ? (
                            <Tooltip title={osDetails?.tipo_ordem_servico}>
                              <Chip
                                size="small"
                                sx={{
                                  ...styles.chip,
                                  backgroundColor:
                                    theme.palette.colors.pink.medium,
                                }}
                                label={osDetails?.tipo_ordem_servico}
                              />
                            </Tooltip>
                          ) : null}
                        </InfoField>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField
                          label="Aberto em"
                          value={
                            osDetails?.data_cadastro_timestamp
                              ? dayjs(
                                  osDetails?.data_cadastro_timestamp,
                                )?.format("DD/MM/YY HH:mm")
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField
                          label="Data programada"
                          value={
                            osDetails?.data_inicio_programado
                              ? dayjs(osDetails?.data_inicio_programado).format(
                                  "DD/MM/YY HH:mm",
                                )
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} lg={4}>
                        <InfoField
                          label="Data término"
                          value={
                            osDetails?.data_termino_programado
                              ? dayjs(
                                  osDetails?.data_termino_programado,
                                ).format("DD/MM/YY HH:mm")
                              : ""
                          }
                        />
                      </Grid>
                      {osDetails?.data_termino_executado_timestamp && (
                        <Grid item xs={12} sm={6} lg={4}>
                          <InfoField
                            label="Finalizado em"
                            value={dayjs(
                              osDetails?.data_termino_executado_timestamp,
                            )?.format("DD/MM/YY HH:mm")}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Box>

                  <Divider />

                  <Box sx={styles.cardSecao}>
                    <Box sx={styles.cardSecaoHeader}>
                      <Typography sx={styles.cardSecaoTitulo}>
                        Descrição do serviço
                      </Typography>
                      {osDetails?.descricao_servico && (
                        <CopyButton
                          value={osDetails?.descricao_servico}
                          setSnackbar={setSnackbar}
                          title="Copiar descrição do serviço"
                          mensagem="Descrição do serviço copiada!"
                        />
                      )}
                    </Box>
                    {osDetails?.descricao_servico ? (
                      formatDescricao(osDetails?.descricao_servico)
                    ) : (
                      <Typography sx={styles.textoVazio}>
                        Nenhuma descrição informada.
                      </Typography>
                    )}
                  </Box>

                  {osDetails?.descricao_fechamento && (
                    <>
                      <Divider />
                      <Box sx={styles.cardSecao}>
                        <Box sx={styles.cardSecaoHeader}>
                          <Typography sx={styles.cardSecaoTitulo}>
                            Descrição de fechamento
                          </Typography>
                          <CopyButton
                            value={osDetails?.descricao_fechamento}
                            setSnackbar={setSnackbar}
                            title="Copiar descrição de fechamento"
                            mensagem="Descrição de fechamento copiada!"
                          />
                        </Box>
                        {formatDescricao(osDetails?.descricao_fechamento)}
                      </Box>
                    </>
                  )}

                  {osDetails?.tecnicos?.length > 0 && (
                    <>
                      <Divider />
                      <Box sx={styles.cardSecao}>
                        <Typography sx={styles.cardSecaoTitulo}>
                          Técnicos
                        </Typography>
                        <Box sx={styles.containerTecnicos}>
                          {osDetails?.tecnicos?.map((tecnico) => (
                            <Box
                              key={tecnico?.id || tecnico?.name}
                              sx={styles.boxDataTecnico}
                            >
                              <Avatar
                                src={tecnico?.imagem}
                                alt={tecnico?.name}
                                sx={styles.avatarTecnico}
                              />
                              <Typography sx={styles.nomeTecnico}>
                                {tecnico?.name}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </>
                  )}

                  {osDetails?.anexos?.length > 0 && (
                    <>
                      <Divider />
                      <Box sx={styles.cardSecao}>
                        <Typography sx={styles.cardSecaoTitulo}>
                          Anexos ({osDetails?.anexos?.length})
                        </Typography>
                        <Box sx={styles.containerAnexos}>
                          {osDetails?.anexos?.map((anexo) => (
                            <Paper
                              key={anexo.id_arquivo_upload}
                              elevation={2}
                              sx={styles.paperAnexo}
                            >
                              <a
                                href={anexo.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={anexo.link_thumb || anexo.link}
                                  alt={anexo.nome}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease-in-out",
                                  }}
                                />
                              </a>
                            </Paper>
                          ))}
                        </Box>
                      </Box>
                    </>
                  )}
                </Paper>
              </Box>
            </Box>
          </Box>
        </>
      )}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        <MenuItem
          disabled={paramsEditOs?.statusOs === "finalizado"}
          onClick={handleEditOS}
        >
          <ListItemIcon>
            <EditOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Editar</ListItemText>
        </MenuItem>
        <MenuItem onClick={getOsHistorico}>
          <ListItemIcon>
            <HistoryOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText>Histórico</ListItemText>
        </MenuItem>
      </Menu>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={closeNewOs}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />
    </Box>
  );
}
